import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateCategory from "./UpdateCategory";
import { config } from "../../../config";

const apiUrl = config.apiUrl;

const ViewCategory = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  // Fetch category details from API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${apiUrl}/categories`);
        setCategories(response.data.categories);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching category details:", err);
        setLoading(false);
        setError("Failed to load category details.");
      }
    };

    fetchCategories();
  }, []);

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Edit Click
  const handleEditClick = (category) => {
    setEditingCategory(category.id);
    setFormData({
      name: category.name,
      description: category.description,
    });
  };

  // Handle Delete Category
const handleDelete = async (categoryId) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await axios.delete(`${apiUrl}/categorydelete/${categoryId}`);
        alert("Category deleted successfully");
        
        setCategories((prev) => prev.filter((category) => category.id !== categoryId));
      } catch (err) {
        console.error("Error deleting category:", err);
        setError("An error occurred while deleting the category.");
      }
    }
  };
  

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.put(`${apiUrl}/categoriesupdate/${editingCategory}`, formData);
      alert("Category updated successfully");

      setCategories((prev) =>
        prev.map((category) =>
          category.id === editingCategory ? { ...category, ...formData } : category
        )
      );

      setEditingCategory(null);
    } catch (err) {
      console.error("Error updating category:", err);
      setError("An error occurred while updating the category.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Category Page</h2>
      {error && <p className="text-red-500">{error}</p>}
      {categories.length === 0 ? (
        <p>No categories found.</p>
      ) : (
        <table border="1" className="table-auto w-full text-left">
          <thead>
            <tr>
              <th className="border px-4 py-2">Category Name</th>
              <th className="border px-4 py-2">Category Description</th>
              <th className="border px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => (
              <tr key={category.id}>
                {!editingCategory || editingCategory !== category.id ? (
                  <>
                    <td className="border px-4 py-2">{category.name}</td>
                    <td className="border px-4 py-2">{category.description}</td>
                    <td className="border px-4 py-2">
                        <button
                            onClick={() => handleEditClick(category)}
                            className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                        >
                            Edit
                        </button>
                        <button
                            onClick={() => handleDelete(category.id)}
                            className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                        >
                            Delete
                        </button>
                    </td>

                  </>
                ) : (
                  <td colSpan={3}>
                    <UpdateCategory
                      formData={formData}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                      error={error}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ViewCategory;
